import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-modal',
  templateUrl: './modal.component.html',
  imports: [NgxBootstrapIconsModule],
})
export class ModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);

  @Input() type?: string;
  @Input() header?: string;
  @Input() message?: string;
  @Input() confirmMode = false;
  @Input() confirmLabel = 'Confirmer';
  ngOnInit() {
    this.activeModal.update({
      centered: true,
      backdropClass: 'opacity-50 bg-body',
    });
  }
  close(value: boolean) {
    this.activeModal.close(value);
  }
}
